module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "0em",
      "background": "#ffffff"
    },
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "section"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container is-wide"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _vm._e()]) : _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "0.2em",
      "background-color": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "header-wrap-inner",
    staticStyle: {
      "background-color": "#ffffff",
      "margin": "0",
      "padding": "0.5em",
      "padding-left": "1em",
      "border": "none"
    }
  }, [_c('li', {
    staticClass: "header-left-2"
  }, [_c('a', {
    staticClass: "header-nav-back card-link",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "color": "#000000",
      "font-size": "16px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Back to Catalog")])])]), _vm._v(" "), _c('li', {
    staticClass: "header-right-2"
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "font-size": "14px",
      "color": "#000000",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.toggleSection('shareBox')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt",
    staticStyle: {
      "color": "#000000",
      "font-size": "12px"
    }
  }), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" Share")])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card pb_img_box"
  }, [_c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.product.product_images), function(img) {
    return _c('li', {}, [(img.product_image && (img.product_image != '' && img.product_image != 'error')) ? _c('img', {
      staticClass: "pb_img",
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "pb_img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length > 1)) ? _c('div', [_c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_vm._v("Swipe >>")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length > 1)) ? _c('div', {
    staticClass: "img-row",
    staticStyle: {
      "display": "none",
      "margin-top": "0em"
    }
  }, _vm._l((_vm.product.product_images), function(img) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-display-image', img)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    })])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both !important"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row prd-info",
    staticStyle: {
      "margin": "1em",
      "margin-top": "0.2em",
      "clear": "both"
    }
  }, [_c('div', {
    staticClass: "card-row"
  }, [_c('h1', [_vm._v("₦" + _vm._s(_vm.product_item.product_item_price_f))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card-row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h4', {
    staticClass: "t-intro"
  }, [_vm._v("Order Add-ons")]), _vm._v(" "), _c('p', [_vm._v("Items you should buy together with this order")]), _vm._v(" "), _c('div', {
    staticClass: "card o-addons"
  }, [_c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.product.product_addons), function(prd) {
    return _c('li', {}, [(prd.product_images[0] && (prd.product_images[0] != '' && prd.product_images[0] != 'error')) ? _c('img', {
      staticClass: "oad-img",
      attrs: {
        "src": _vm.img_product_url + prd.product_images[0].product_image,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "oad-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(prd.product_name))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("₦" + _vm._s(prd.product_items[0].product_item_price_f))])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length > 1)) ? _c('div', [_c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_vm._v("Swipe >>")])]) : _vm._e()])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card-row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h4', {
    staticClass: "t-intro"
  }, [_vm._v("Details")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_description))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1em",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.product.product_addons && (_vm.product.product_addons.length != 0)) ? _c('div', [_c('h5', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("Select additional items")]), _vm._v(" "), _vm._l((_vm.product.product_addons), function(product, index) {
    return _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.setProductAddOn(product);
          _vm.openModal('activeProductAddonModal')
        }
      }
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', [_c('p', {
      staticStyle: {
        "font-size": "10px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()])])])])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em",
      "padding-bottom": "0.2em",
      "border-bottom": "#f3f2f2 solid"
    }
  }, [_c('a', {
    staticClass: "col-xs-4 sp-app-default-color card-link",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "font-size": "18px"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('descr')
      }
    }
  }, [(_vm.tab_view.descr) ? _c('div', {
    staticStyle: {
      "border-bottom": "#f33e5c solid 3px"
    }
  }, [_vm._v("Details")]) : _c('div', [_vm._v("Details")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-4 sp-app-default-color card-link",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "font-size": "18px"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('info')
      }
    }
  }, [(_vm.tab_view.info) ? _c('div', {
    staticStyle: {
      "border-bottom": "#f33e5c solid 3px"
    }
  }, [_vm._v("Shipping")]) : _c('div', [_vm._v("Shipping")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-4 sp-app-default-color card-link",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "font-size": "18px",
      "text-decoration": "none",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('reviews')
      }
    }
  }, [(_vm.tab_view.reviews) ? _c('div', {
    staticStyle: {
      "border-bottom": "#f33e5c solid 3px"
    }
  }, [_vm._v("Reviews "), (_vm.product.product_reviews && (Object.keys(_vm.product.product_reviews).length > 0)) ? _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("(" + _vm._s(Object.keys(_vm.product.product_reviews).length) + ")")]) : _vm._e()]) : _c('div', [_vm._v("Reviews "), (_vm.product.product_reviews && (Object.keys(_vm.product.product_reviews).length > 0)) ? _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("(" + _vm._s(Object.keys(_vm.product.product_reviews).length) + ")")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "2em 1em"
    }
  }, [(_vm.tab_view.descr) ? _c('div', [_c('div', {
    staticClass: "w-richtext"
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v(_vm._s(_vm.product.product_description) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.tab_view.info) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "info-blocks"
  }, [(_vm.product.product_business_delivery_options.length > 0) ? _c('div', {
    staticClass: "info-block col-md-12 col-xs-12 card-colord-pad card-colord-01",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-right-2 col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "prd-delivery-list"
  }, _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return (delivery.business_delivery_business != 1) ? _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦\r\n                                  "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(_vm._s(fee.product_delivery_fee) + "\r\n                                      ")]) : _vm._e()])
    })) : _c('span', [_vm._v("\r\n                                    " + _vm._s(delivery.business_delivery_option_price) + "\r\n                                  ")])]) : _vm._e()
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.tab_view.reviews) ? _c('div', [_c('br'), _vm._v(" "), (_vm.product.product_reviews && Object.keys(_vm.product.product_reviews).length == 0) ? _c('p', {
    staticStyle: {
      "color": "#129efc"
    }
  }, [_vm._v("\r\n                        No reviews yet.\r\n                      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.product.product_reviews), function(review, rdex) {
    return _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-circle"
    }, [(review.product_reviewed_by_image && (review.product_reviewed_by_image != '')) ? _c('img', {
      attrs: {
        "src": review.product_reviewed_by_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right",
      staticStyle: {
        "padding-left": "6px"
      }
    }, [_c('div', {}, [_c('p', [_vm._v(_vm._s(review.product_review) + "\r\n                              ")]), _c('div', {
      staticStyle: {
        "color": "#ffd900"
      }
    }, [_vm._l((parseInt(review.product_rate)), function(index) {
      return _c('span', {
        staticClass: "fa is-filled"
      }, [_vm._v("")])
    }), _vm._l(((5 - parseInt(review.product_rate))), function(index) {
      return _c('span', {
        staticClass: "fa is-filled"
      }, [_vm._v("")])
    })], 2), _vm._v("\r\n                              " + _vm._s(review.product_reviewed_by)), _c('br'), _vm._v("\r\n                              " + _vm._s(review.product_review_date) + "\r\n                            "), _c('p')])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section",
    staticStyle: {
      "margin-bottom": "5em"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "3em"
    }
  }, _vm._l((_vm.related_products), function(product, index) {
    return _c('div', {
      staticClass: "card card-row card-col-2 col-xs-12",
      staticStyle: {
        "text-align": "left",
        "background": "#ffffff",
        "border-radius": "0px",
        "margin-bottom": "0.6em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + product.product_business_username + '/' + product.product_url_name
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "45%"
      }
    }, [_c('div', {
      staticClass: "card-col-img"
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "55%",
        "padding-top": "0.1em"
      }
    }, [_c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px",
        "padding-left": "2em"
      }
    }, [_c('p', [_vm._m(2, true), _vm._v(" "), _c('span', {
      staticClass: "prd-name"
    }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', [_vm._m(3, true), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "p-info"
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._m(4, true), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "p-info"
    }, [_vm._v("YES")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._m(5, true), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "p-info"
    }, [_vm._v("6")]) : _vm._e()]), _vm._v(" "), _vm._m(6, true)])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section",
    staticStyle: {
      "margin-bottom": "10em"
    }
  }, [_vm._v("   ")]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "z-index": "2"
    },
    attrs: {
      "id": "sumBrief"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "1"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%",
      "height": "auto",
      "padding": "0.1em",
      "background-color": "rgba(0, 0, 0, 0)",
      "color": "#ffffff",
      "border-top": "none",
      "border-radius": "45px 45px 0px 0px"
    },
    attrs: {
      "id": "sumBrief2"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "background-color": "none",
      "height": "3em",
      "float": "right"
    }
  }, [_c('a', {
    staticClass: "cta-btn class",
    staticStyle: {
      "background-color": "#000000",
      "color": "#ffffff",
      "padding": "15px 14px",
      "height": "3em",
      "border-radius": "4px"
    },
    attrs: {
      "href": '/make/order/' + _vm.product.product_url_name
    }
  }, [_vm._v("Make Order")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000"
    },
    attrs: {
      "id": "shareBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": _vm.showCartOptions
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "background": "#ffffff",
      "color": "#000000",
      "border-top": "#061433 solid",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.toggleSection('shareBox')
      }
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _vm._m(8)])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000"
    },
    attrs: {
      "id": "shareBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": _vm.showCartOptions
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "background": "#ffffff",
      "color": "#000000",
      "border-top": "#061433 solid",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.toggleSection('shareBox')
      }
    }
  }, [_vm._m(9), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _vm._m(10)])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000"
    },
    attrs: {
      "id": "activeProductAddonModal"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": _vm.showCartOptions
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "background": "#ffffff",
      "color": "#000000",
      "border-top": "#061433 solid",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.toggleSection('activeProductAddonModal')
      }
    }
  }, [_vm._m(11), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    key: _vm.setproductAddonKey,
    staticClass: "card"
  }, [_c('div', {
    staticClass: "sp-prd-attr-block",
    staticStyle: {
      "width": "100%",
      "margin-top": "2em"
    }
  }, [_c('div', {
    staticClass: "card pb_img_box",
    staticStyle: {
      "z-index": "1",
      "padding": "0"
    }
  }, [((_vm.product_addon.product_images && _vm.product_addon.product_images[0].product_image != 'error')) ? _c('img', {
    staticStyle: {
      "max-height": "150px"
    },
    attrs: {
      "src": _vm.img_product_url + _vm.product_addon.product_images[0].product_image,
      "alt": ""
    }
  }) : _c('img', {
    staticStyle: {
      "max-height": "150px"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "color": "#ff5566"
    }
  }, [_vm._v(_vm._s(_vm.product_addon.product_name))]), _vm._v(" "), (_vm.product_addon.product_can_set_custom_price == 1) ? _c('table', {
    staticClass: "tb-cols",
    staticStyle: {
      "width": "100%",
      "margin": "0"
    }
  }, [_c('tr', [_vm._m(12), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right form-group",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.product_addon_item.product_item_price))]), _vm._v(" "), (_vm.product_addon_item.product_item_actual_price != 0) ? _c('p', {
    staticClass: "attr-intro-desc prd-price prd-discounted-price"
  }, [_c('del', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_addon_item.product_item_actual_price_f))])]) : _c('p', {
    staticClass: "attr-intro-desc prd-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_addon_item.product_item_price_f))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_addon_item.product_item_order_custom_set_price),
      expression: "product_addon_item.product_item_order_custom_set_price"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100px !important"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product_addon_item.product_item_order_custom_set_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_addon_item.product_item_order_custom_set_price = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setProductCustomPrice
    }
  }, [_vm._v("OK")])])])])]) : _c('table', {
    staticClass: "tb-cols",
    staticStyle: {
      "width": "100%",
      "margin": "0"
    }
  }, [_c('tr', [_vm._m(13), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right",
    staticStyle: {
      "padding": "5px"
    }
  }, [(_vm.product_addon_item.product_item_actual_price != 0) ? _c('p', {
    staticClass: "attr-intro-desc prd-price prd-discounted-price"
  }, [_c('del', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_addon_item.product_item_actual_price_f))])]) : _c('p', {
    staticClass: "attr-intro-desc prd-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_addon_item.product_item_price_f))])])])]), _vm._v(" "), (_vm.product_addon_item.product_item_actual_price != 0) ? _c('tr', [_vm._m(14), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right col-xs-8",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('p', {
    staticClass: "attr-intro-desc prd-discount-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_addon_item.product_item_price_f))])])])]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "tb-cols",
    staticStyle: {
      "width": "100%",
      "margin": "0"
    }
  }, [(((_vm.product_addon.product_set_groups != 0))) ? _c('tr', [_c('td', {
    staticClass: "td-col-2"
  }, [(((_vm.product_addon.product_set_groups != 0))) ? _c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Select: ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right"
  }, [_c('table', [_c('tr', _vm._l((_vm.product_addon.product_item_groups), function(pg) {
    return _c('td', {
      staticStyle: {
        "padding-right": "2px"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item-group', pg)
        }
      }
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('span', {
      staticClass: "product-item-group box-cube",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticStyle: {
        "width": "45px",
        "height": "45px"
      },
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticStyle: {
        "width": "45px",
        "height": "45px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    }), _c('br')]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('span', {}, [_c('span', {
      staticClass: "product-item-group box-color-cube",
      style: ({
        background: pg.product_item_group_color
      }),
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.product.product_item_groups.length > 1) ? _c('span', {
      staticStyle: {
        "font-size": "12px",
        "font-weight": "500"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name))]) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_cart_group_message) ? _c('p', {
    staticClass: "p-tiny-info",
    staticStyle: {
      "margin-top": "-1em",
      "padding-top": "1em",
      "float": "left",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_cart_group_message))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (((_vm.product_addon_item_group.product_items) && (_vm.product_addon_item_group.product_items.length != 0))) ? _c('tr', {
    staticStyle: {
      "clear": "both"
    }
  }) : _vm._e(), (((_vm.product_addon.product_set_items != 0) && (_vm.product_addon.product_set_items_params_check != 0))) ? _c('tr', [_vm._m(15), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right"
  }, [_c('ul', {
    staticClass: "prd-color-block",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, _vm._l((_vm.product_addon_item_group.product_items), function(pt) {
    return _c('li', {
      staticClass: "items-list-tiny listnone"
    }, [_c('span', {
      staticClass: "product-item listnone",
      attrs: {
        "id": pt.product_item_id + 'PRT'
      }
    }, [(_vm.product.product_service == 'P') ? _c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "product-item listnone",
      attrs: {
        "id": pt.product_item_id + 'PRT'
      }
    }, [(_vm.product.product_service == 'S') ? _c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_cart_item_message) ? _c('p', {
    staticClass: "p-tiny-info",
    staticStyle: {
      "margin-top": "-0.1em",
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.data_cart_item_message))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('tr', [_vm._m(16), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('p', {
    staticClass: "attr-intro-desc"
  }, [_vm._v(_vm._s(_vm.product_addon_item.product_item_weight) + " (Kg)")])])])]), _vm._v(" "), (_vm.is_product_in_cart) ? _c('tr', {
    staticStyle: {
      "border": "dotted 1px #96c5f5",
      "padding": "5px 2px"
    }
  }, [_c('td', {
    staticClass: "td-col-10"
  }, [_c('p', [_vm._v("This Item is in your cart \r\n                          "), _c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "width": "12em",
      "cursor": "pointer",
      "line-height": "1.8"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])])])]) : _c('tr', [_vm._m(17), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right",
    staticStyle: {
      "margin": "-1em 5px"
    }
  }, [_c('div', {}, [_c('a', {
    staticClass: "col-xs-2 qty-btn qty-btn-sm",
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "none",
      "padding": "0"
    },
    on: {
      "click": function($event) {
        _vm.removeQuantity(_vm.product_addon_item.product_item_order_quantity)
      }
    }
  }, [_vm._v("–")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_addon_item.product_item_order_quantity),
      expression: "product_addon_item.product_item_order_quantity"
    }],
    key: _vm.product_item_quantity_key,
    staticClass: "col-xs-4 qty-input qty-input-sm",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product_addon_item.product_item_order_quantity)
    },
    on: {
      "change": function($event) {
        _vm.checkOrderQuantity(_vm.product_addon_item.product_item_order_quantity)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_addon_item.product_item_order_quantity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "col-xs-2 qty-btn qty-btn-sm",
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "none",
      "padding": "0"
    },
    on: {
      "click": function($event) {
        _vm.addQuantity(_vm.product_addon_item.product_item_order_quantity)
      }
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.check_order_quantity))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [((_vm.product_addon.selected)) ? _c('p', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Selected")]) : _c('button', {
    staticClass: "btn sp-button-sm",
    staticStyle: {
      "background": "#fc4112 !important",
      "color": "#ffffff !important"
    },
    attrs: {
      "id": "myBtn",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setSelectedProductAddOns(_vm.product_addon)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add to Purchase")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h6', [_vm._v("SHIPPING DETAILS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "font-size": "18px",
      "text-transform": "capitalize"
    }
  }, [_vm._v("Also check these")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "p-title"
  }, [_c('b', [_vm._v("Name: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "p-title"
  }, [_c('b', [_vm._v("Price: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "p-title"
  }, [_c('b', [_vm._v("In Stock: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "p-title"
  }, [_c('b', [_vm._v("Available Type: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "0 1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-right"
  }, [_c('span', [_vm._v("Whatsapp")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "sms:?body=hello world"
    }
  }, [_vm._v("Send SMS")])]), _vm._v(" "), _c('div', {
    staticClass: "card-right"
  }, [_c('span', [_vm._v("Whatsapp")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "0 1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-right"
  }, [_c('span', [_vm._v("Whatsapp")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "sms:?body=hello world"
    }
  }, [_vm._v("Send SMS")])]), _vm._v(" "), _c('div', {
    staticClass: "card-right"
  }, [_c('span', [_vm._v("Whatsapp")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Price: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Price: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Discount Price: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Select: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Weight: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Quantity:  ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57d52748"}!./src/pages/Sellpoint/Product/template.html
// module id = 544
// module chunks = 0